import careerController from "../../../controllers/careerController/controller";
import requirementController from "../../../controllers/requirementController/controller";
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';

export default {
    name: 'SimpleTable',
    data(){
        return {
            company: '',
            careerList: [],
            currentPage: 1,
            pageSize: 10,
            totalPages: 0,
            totalCareers: 0, // Total items dari backend
            searchQuery: '',
            requirementList: [],
            career: {
                positions: '',
                status: '',
                deskripsi: '', 
                created_by: '',
                created_by_name: '',
                created_on: '',
            },
            selectedCareer: {
                status: '',
                created_by: '',
                created_by_name: '',
                updated_by: '',
                updated_by_name: '',
                updated_on: '',
            },
            selectedCareerDetail : {
                id : '',
                status : '',
                news_update_by : '',
                news_update_by_name : '',
            },
            careerDetail : [],
        }
    },
    computed: {
        filteredCareer(){
            return this.careerList.filter(career => career.positions.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
        pages(){
            return Math.ceil(this.totalCareers / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },        
    }, 
    methods:{
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.career.created_by = id;
            this.selectedCareer.updated_by = id;
            this.selectedCareer.created_by = id;
            this.selectedCareerDetail.news_update_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.career.created_by_name = name;
            this.selectedCareer.updated_by_name = name;
            this.selectedCareer.created_by_name = name;
            this.selectedCareerDetail.news_update_by_name = name;
        },
        modalEditCareerDetail(id) {
            this.user();
            const selectedDetail = this.careerDetail.find(detail => detail.id === id);
            if (selectedDetail) {
                this.selectedCareerDetail = selectedDetail;
                this.$nextTick(() => {
                    const modal = document.getElementById('editCareerDetail');
                    if (modal) {
                        modal.style.display = 'block';
                        modal.style.background = 'rgba(0,0,0,0.5)'; 
                        modal.classList.add('show');
                        // Tambahkan event listener untuk mencegah klik di luar modal
                        modal.addEventListener('click', (event) => {
                            event.stopPropagation();
                        });
                    }
                });
            }
        },
        closeModalEditCareerDetail() {
            const modal = document.getElementById('editCareerDetail');
            if (modal) {
                modal.classList.remove('show');
                setTimeout(() => {
                    modal.style.display = 'none';
                }, 300);
            }
            this.getCareerDetail(this.career.id);
        },
        showModal(type, id) {
            this.user();
            const career = this.careerList.find(career => career.id === id);
            if (career) {
                this.career = career;
        
                const modalId = {
                    edit: 'editCareer',
                    add: 'addRequirement',
                    editCareer: 'editCareerDetail',
                    default: 'detailCareer'
                }[type] || 'detailCareer';
        
                const modal = document.getElementById(modalId);
        
                if (type === 'add') {
                    this.career.created_by_name = '';
                    this.getRequirement(id);
                    this.getCareerDetail(id);
                }
        
                // Hitung jumlah modal yang sedang dibuka
                const openModals = document.querySelectorAll('.modal.show').length;
        
                // Atur z-index modal baru agar berada di atas modal lainnya
                const newZIndex = 1040 + (10 * openModals); // Default Bootstrap z-index = 1040
                modal.style.zIndex = newZIndex;
        
                // Tambahkan backdrop dengan z-index yang lebih tinggi
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                backdrop.style.zIndex = newZIndex - 1; // Backdrop ada di bawah modal baru
                document.body.appendChild(backdrop);
        
                requestAnimationFrame(() => {
                    backdrop.classList.add('show');
                    modal.style.display = 'block';
                    modal.classList.add('show');
                });
        
                document.body.classList.add('modal-open');
            }
        },
        closeModal() {
            const modalIds = ['tambahCareer', 'editCareer', 'detailCareer', 'addRequirement'];
            modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
                modal.classList.remove('show');
                setTimeout(() => {
                modal.style.display = 'none';
                }, 300);
            }
            });
        
            // Hapus backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
                if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
                }
            }, 300);
            });
        
            // Hapus kelas atau atribut yang mengunci scroll pada body
            const body = document.body;
            body.classList.remove('modal-open');
            body.style.overflow = ''; // Menghapus properti overflow jika ada
            this.fetchCareers();
            this.resetForm();
            this.user();
        }, 
        resetForm() {
            this.career.positions = '';
            this.career.status = '';
            this.career.deskripsi = '';
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchCareers();
            }
        },
        async fetchCareers() {
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await careerController.fetchCareers(query, this.currentPage, this.pageSize, company);
                this.careerList = response.data;
                this.totalAllCareers();
            } catch (error) {
                console.error('Error fetching careers:', error);
                throw error;
            }
        },
        async totalAllCareers() {
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await careerController.totalAllCareers(query, company);
                this.totalCareers = response.data;
            } catch (error) {
                console.error('Error fetching careers:', error);
                throw error;
            }
        },
        async addCareer(){
            try {
                const {positions, deskripsi, status, created_by, created_by_name} = this.career;
                if (!positions || !deskripsi || !status || !created_by || !created_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                }
                const company = this.company;
                const now = new Date();
                const created_on = now.toISOString().slice(0, 19).replace('T', ' '); // Format MySQL
                const add = {
                    positions: this.career.positions,
                    description: this.career.deskripsi,
                    is_active: this.career.status,
                    id_company: company,
                    created_by: this.career.created_by,
                    created_by_name: this.career.created_by_name,
                    created_on: created_on
                }
                await careerController.addCareer(add);
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil menambahkan data',
                    timer: 1500
                })
                this.closeModal();
                this.fetchCareers();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal menambahkan data: ' + error.message,
                    timer: 1500
                })
            }
        },
        async updateCareer(){
            try {
                const id = this.career.id;
                const positions = this.career.positions;
                const deskripsi = this.career.deskripsi;
                const status = this.career.status;
                const updated_by = this.selectedCareer.updated_by;
                const updated_by_name = this.selectedCareer.updated_by_name;
                if (!id || !positions || !deskripsi || !status || !updated_by || !updated_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const now = new Date();
                const updated_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const update = {
                    id: this.career.id,
                    positions: this.career.positions,
                    description: this.career.deskripsi,
                    is_active: this.career.status,
                    updated_by: this.selectedCareer.updated_by,
                    updated_by_name: this.selectedCareer.updated_by_name,
                    updated_on: updated_on
                }
                await careerController.updateCareer(update);
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil memperbaharui data',
                    timer: 1500
                })
                this.closeModal();
                this.fetchCareers();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memperbaharui data: ' + error.message,
                    timer: 1500
                })
            }
        },
        async deleteCareer(careerId) {            
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    await careerController.deleteCareer(careerId);
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil menghapus data',
                        timer: 1500
                    })
                    this.fetchCareers();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Gagal menghapus data: ' + error.message,
                        timer: 1500
                    })
                }
            }
        },
        async getRequirement(id){
            try{
                const company = this.company;
                const response = await requirementController.getOnlyRequirements(id, company);
                this.requirementList = response.data;
            } catch (error) {
                console.error('Error fetching requirements:', error);
                throw error;
            }
        },
        async getCareerDetail(id){
            try{
                const response = await careerController.getCareerDetail(id);
                this.careerDetail = response.data;
            } catch (error) {
                console.error('Error fetching career details:', error);
                throw error;
            }
        },
        async addMappingRequirement(){
            try {
                const career_id = this.career.id;
                const requirement_id = this.career.id_requirement;
                const is_active = this.selectedCareer.status;
                const id_company = this.company;
                const created_by = this.selectedCareer.created_by;
                const created_by_name = this.selectedCareer.created_by_name;
                if (!career_id || !requirement_id || !is_active || !created_by || !created_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const now = new Date();
                const created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const mapping = {career_id, requirement_id,id_company, is_active, created_by, created_by_name, created_on};
                const response = await requirementController.addMappingRequirement(mapping);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil menambahkan data',
                        timer: 1500
                    })
                    this.getCareerDetail(career_id);
                    this.getRequirement(career_id);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal menambahkan data: ' + error.message,
                    timer: 1500
                })
            }
        },
        async updateStatusCareerDetail() {
            try {
                const id = this.selectedCareerDetail.id;
                const career_id = this.selectedCareerDetail.career_id;
                const is_active = this.selectedCareerDetail.is_active;
                const updated_by = this.selectedCareer.created_by;
                const updated_by_name = this.selectedCareer.created_by_name;
                if (!id || !is_active || !updated_by || !updated_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const now = new Date();
                const updated_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const updateData = {id, is_active, updated_by, updated_by_name, updated_on};
                const response = await careerController.updateStatusCareerDetail(updateData);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil memperbaharui data',
                        timer: 1500
                    })
                    this.closeModalEditCareerDetail();
                    this.resetForm();
                    this.getRequirement(career_id);
                    this.getCareerDetail(career_id);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal memperbaharui data',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memperbaharui data: ' + error.message,
                    timer: 1500
                })
            }
        }, 
        onCompanyChange(newCompany) {
            this.company = newCompany;
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery: {
            handler: 'fetchCareers'
        },
        company: {
            handler: 'fetchCareers'
        }
    },
}